<template>
  <div class="condition-item">
    <span>筛选条件{{ index + 1 }}</span>
    <a-select
      showSearch
      v-model="list[index].name"
      style="width: 216px"
      :filter-option="false"
      placeholder="请选择筛选维度指标"
      @search="getFields"
      @change="changeNorm"
    >
      <a-select-option v-for="item in normList" :key="item.field" :value="item.field">
        <div :title="item.desc">{{ item.name }}</div>
      </a-select-option>
    </a-select>
    <a-select v-model="list[index].op" style="width: 146px">
      <template v-if="dataType === 'STRING'">
        <a-select-option value="like">包含</a-select-option>
        <a-select-option value="notLike">不包含</a-select-option>
        <a-select-option value="startWith">开始以</a-select-option>
        <a-select-option value="notStartWith">开始不是以</a-select-option>
        <a-select-option value="endWith">结束以</a-select-option>
        <a-select-option value="notEndWith">结束不是以</a-select-option>
        <a-select-option value="eq">等于</a-select-option>
      </template>
      <a-select-option value="in" v-if="dataType === 'ENUM'">包含</a-select-option>
      <a-select-option value="between" v-if="dataType === 'TIME'">介于</a-select-option>
      <template v-if="dataType === 'NUMBER'">
        <a-select-option value="gt">大于</a-select-option>
        <a-select-option value="eq">等于</a-select-option>
        <a-select-option value="lt">小于</a-select-option>
        <a-select-option value="gte">大于等于</a-select-option>
        <a-select-option value="lte">小于等于</a-select-option>
      </template>
    </a-select>
    <a-input-number
      v-if="dataType === 'NUMBER'"
      v-model="list[index].value"
      style="width: 216px"
    />
    <!-- <a-select
      class="enum-select"
      :maxTagCount="1"
      :maxTagTextLength="5"
      mode="multiple"
      v-if="dataType === 'ENUM'"
      v-model="list[index].value"
      style="width: 216px"
      placeholder="请输入条件"
    >
      <a-select-option :value="v.dkey" v-for="v in enumList" :key="v.dkey">{{
        v.cname
      }}</a-select-option>
    </a-select> -->
    <a-input
      v-model.trim="list[index].value"
      placeholder="请输入条件"
      v-if="dataType === 'STRING' || dataType === 'ENUM'"
      style="width: 216px"
    />
    <a-range-picker
      v-model="list[index].value"
      valueFormat="YYYY-MM-DD"
      v-if="dataType === 'TIME'"
    />
    <icon-font
      class="delete-btn"
      type="icon-Close-Circle-Fill"
      @click="$emit('delete')"
    ></icon-font>
  </div>
</template>

<script>
import { getFields } from "@/api/basicCyberData";
import { getEnumDataNew } from "@/api/template";

export default {
  name: "FilterConditionItem",
  props: ["list", "index", "dataSetValue", "fields", 'tableId'],
  data() {
    return {
      normList: [],
      enumList: [],
      value: {}
    };
  },
  computed: {
    dataType() {
      return this.list[this.index]?.dataType;
    },
  },
  watch: {
    fields(newVal, oldVal) {
      if(JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.getFields()
      }
    }
  },
  mounted() {
    this.getFields(this.list[this.index]?.name || undefined);
    console.log(this.list[this.index])
    if (this.list[this.index]?.dataType === "ENUM") {
      // this.getEnumData(this.list[this.index]?.name);
    }
  },
  methods: {
    // 获取枚举列表
    getEnumData(field) {
      getEnumDataNew(1, field).then((res) => {
        this.enumList = res.data;
      });
    },
    changeNorm(val) {
      let obj = this.normList.find((v) => v.field === val);
      console.log(obj);
      let dataType = obj.dataType;
      if(this.list[this.index]) {
        this.list[this.index].dataType = dataType;
        this.list[this.index].value = undefined;
        this.list[this.index].id = obj.id;
        if (dataType === "NUMBER") {
          this.list[this.index].value = 0;
          this.list[this.index].op = "gt";
        } else if (dataType === "STRING") {
          this.list[this.index].value = "";
          this.list[this.index].op = "like";
        } else if (dataType === "ENUM") {
          this.list[this.index].value = [];
          this.list[this.index].op = "in";
          // this.getEnumData(obj.field);
        } else if (dataType === "TIME") {
          this.list[this.index].value = [];
          this.list[this.index].op = "between";
        }
      }
    },
    async getFields(keyWord) {
      const params = {
        mediaCode: this.dataSetValue,
      };
      const odata = {
        fields: this.fields,
        filterEnable: true,
        searchKeyWord: keyWord,
        tableId: this.tableId() || undefined
      };
      const { code, data } = await getFields(params, odata);
      this.normList = data?.recordList || [];
      if (code != "200") return;
    },
  },
};
</script>
<style lang="less" scoped>
.condition-item {
  height: 48px;
  line-height: 48px;
  width: 100%;
  margin: 4px 0px;
  padding-left: 16px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  & > * {
    margin-right: 8px;
  }
  .delete-btn {
    position: absolute;
    right: 8px;
    top: 16px;
    color: #9ca9cb;
    font-size: 16px;
    cursor: pointer;
    display: none;
  }
  .enum-select {
    /deep/ .ant-select-selection--multiple {
      height: 32px;
      overflow: hidden;
    }
  }
  &:hover {
    background: #F7F9FE;
    .delete-btn {
      display: block;
    }
  }
}
</style>
